<template>
  <div class="item-video-modal-bg" v-if="board.videoView.show">
    <form @keyup.esc="close()" tabindex="0" >
      <v-layout id='item_video_modal' class='item-video-modal' v-resize="onResize" :style="{'left': left, 'top': top}">
        <div class="view-wrap">
          <!-- 타이틀바-->
          <v-layout class="view-title-bar" align-center justify-space-between row shrink>
            <v-flex class="text-xs-left hidden-md-and-up" shrink>
              <v-btn fit icon @click="close()"><v-icon>keyboard_arrow_left</v-icon></v-btn>
            </v-flex>
            <v-flex :class="['text-xs-left', 'title-text', ($vuetify.breakpoint.mdAndUp) ? 'pl-4' : 'pl-1']">
              동영상보기
            </v-flex>
            <v-flex class="text-xs-right hidden-sm-and-down mr-1" shrink>
              <v-btn fit icon @click="close()"><v-icon>close</v-icon></v-btn>
            </v-flex>
          </v-layout>
          <!-- 내용-->
          <div class="view-content-area">
            <v-layout class="column fill-height">
              <v-flex class="shrink" style="line-height: 1;">
                <!-- 영상 플레이 영역-->
                <v-layout class="align-center fill-height view-play-area">
                  <v-flex>
                    <youtube id="view_player" width="100%" :height="getYoutubeHeight() + 'px'" :video-id="getYoutubeCode" ref="video-view-player" ></youtube>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="grow">
                <!-- 리스트 영역-->
                <div class="view-list-area">
                  <v-layout class="column fill-height">
                    <v-flex class="shrink tab-area">
                      <v-tabs fixed-tabs grow v-model="board.videoView.tab">
                        <v-tabs-slider color="title_color" grow></v-tabs-slider>
                        <v-tab href="#1" @click="tabclick(1)">
                          핫딜 매물
                        </v-tab>
                        <v-tab href="#2" @click="tabclick(2)">
                          내방 구하는 팁
                        </v-tab>
                      </v-tabs>
                    </v-flex>
                    <v-flex class="grow">
                      <div class="view-list" id="video_list_scroll_area">
                        <v-layout class="fill-height" v-scroll:#video_list_scroll_area="onScroll">
                          <v-flex v-if="board.videoView.tab == 1">
                            <div class="list-wrap">
                              <!-- 배너 -->
                              <div class="list-banner">
                                <img :src="`${$utile.getStaticUrl()}/modal/video-tab1-banner-1.jpg`"/>
                              </div>
                              <!-- 리스트 시작-->
                              <div class="list-tot-count" >
                                영상등록개수 <span class="num">{{board.videoView.tab1.totcount}}</span>개
                              </div>
                              <div class="video-list">
                                <v-layout row wrap>
                                  <v-flex v-if="board.videoView.tab1.list.length > 0" v-for="(item, i) in board.videoView.tab1.list" :key="i" xs6  class="list-item">
                                    <router-link :to="{ path: 'modal', query: { video: 1, view: item.code }}">
                                      <img :src="`https://img.youtube.com/vi/${item.code}/0.jpg`">
                                    </router-link>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </div>
                          </v-flex>
                          <v-flex v-if="board.videoView.tab == 2">
                            <div class="list-wrap">
                              <!-- 배너 -->
                              <div class="list-banner">
                                <img :src="`${$utile.getStaticUrl()}/modal/video-tab2-banner-1.jpg`"/>
                              </div>
                              <!-- 리스트 시작-->
                              <div class="list-tot-count" >
                                영상등록개수 <span class="num">{{board.videoView.tab2.totcount}}</span>개
                              </div>
                              <div class="video-list">
                                <v-layout row wrap>
                                  <v-flex v-if="board.videoView.tab2.list.length > 0" v-for="(item, i) in board.videoView.tab2.list" :key="i" xs6  class="list-item">
                                    <router-link :to="{ path: 'modal', query: { video: 2, view: item.code }}">
                                      <img :src="`https://img.youtube.com/vi/${item.code}/0.jpg`">
                                    </router-link>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </div>

        </div>
      </v-layout>
    </form>
  </div>
</template>

<script>
// import Config from '@/config'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'VideoView',
  data: () => ({
    video_src: '',
    top: 0,
    left: 0
  }),
  mounted () {
    // 창이 닫히는지 확인
    this.$store.watch(() => this.board.videoView.show, (newValue, oldValue) => {
      if (!newValue) {
        this.$router.replace('map')
      } else if (newValue && newValue !== oldValue) { // 창 오픈시
        this.listReset()
        this.listUpdate(1)
        this.listUpdate(2)
      }
    })
  },
  components: {
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      board: state => state.board,
      config: state => state.config
    }),
    getYoutubeCode: function () {
      if (!this.$route.query.view) {
        if (this.$route.query.video === 1) {
          if (this.board.videoView.tab1.list.length > 0) {
            return this.board.videoView.tab1.list[0].code
          } else {
            return ''
          }
        } else if (this.$route.query.video === 2) {
          if (this.board.videoView.tab2.list.length > 0) {
            return this.board.videoView.tab2.list[0].code
          } else {
            return ''
          }
        }
      }
      return this.$route.query.view
    }
  },
  methods: {
    ...mapActions({
      requestBoardData: 'board/requestBoardData'
    }),
    tabclick (val) {
      this.$router.replace({path: 'modal', query: { video: val }})
    },
    getYoutubeWidth () {
      if (document.getElementById('view_player') === null) {
        return 0
      }
      return document.getElementById('view_player').clientWidth
    },
    getYoutubeHeight () {
      return (this.getYoutubeWidth() / 16) * 9
    },
    // 스크롤
    onScroll (e) {
      if (Math.round(e.target.scrollHeight - e.target.clientHeight) === Math.round(e.target.scrollTop)) {
        this.listScrollUpdate()
      }
    },
    listReset () {
      this.board.videoView.tab1.list = []
      this.board.videoView.tab1.offset = 0
      this.board.videoView.tab1.totcount = 0

      this.board.videoView.tab2.list = []
      this.board.videoView.tab2.offset = 0
      this.board.videoView.tab2.totcount = 0
    },
    // 리스트 업데이트
    listUpdate (tab) {
      if (tab === 1) {
        this.requestBoardData({ 'type': 'videoList', 'tab': 1, 'offset': this.board.videoView.tab1.offset }).then((data) => {
          if (data.array.length > 0) {
            this.board.videoView.tab1.offset = this.board.videoView.tab1.offset + data.array.length
            this.board.videoView.tab1.totcount = data.totcount
            const _this = this
            data.array.forEach(function (value) {
              _this.board.videoView.tab1.list.push(value)
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      } else if (tab === 2) {
        this.requestBoardData({ 'type': 'videoList', 'tab': 2, 'offset': this.board.videoView.tab2.offset }).then((data) => {
          if (data.array.length > 0) {
            this.board.videoView.tab2.offset = this.board.videoView.tab2.offset + data.array.length
            this.board.videoView.tab2.totcount = data.totcount
            const _this = this
            data.array.forEach(function (value) {
              _this.board.videoView.tab2.list.push(value)
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    listScrollUpdate () {
      if (this.board.videoView.tab === '1') {
        this.listUpdate(1)
      } else if (this.board.videoView.tab === '2') {
        this.listUpdate(2)
      }
    },
    close () {
      this.board.videoView.show = false
    },
    onResize () {
      if (document.getElementById('item_video_modal') != null) {
        if (this.top === 0) {
          let top = (window.innerHeight / 2) - (document.getElementById('item_video_modal').clientHeight / 2)
          let left = (window.innerWidth / 2)
          this.top = top + 'px'
          this.left = left + 'px'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/VideoView.vue